import { render, staticRenderFns } from "./enrollment-view.vue?vue&type=template&id=590062f2&"
import script from "./enrollment-view.js?vue&type=script&lang=js&"
export * from "./enrollment-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports